import { getAuth } from 'firebase/auth'

export const getUserIdToken = async () => {
  const auth = getAuth()
  const user = auth.currentUser

  if (!user) {
    console.error('User is not authenticated')
    return
  }

  const idtoken = await user.getIdToken()
  return idtoken
}
